import React from 'react'
import { Card } from 'react-bootstrap'
import CardBodyContentContainer from '../../../../common/styles/CardBodyContentContainer'
import CardTitle from '../../../../common/styles/CardTitle'
import BooksitoutIcon from '../../../../config/BooksitoutIcon'
import useUserBookRecommendations from './useUserBookRecommendations'
import UserBookRecommendationListRow from './UserBookRecommendationListRow'
import UserBookRecommendationListRowLoading from './UserBookRecommendationListRowLoading'
import NoContent from '../../../../common/NoContent'
import RowSpacer from '../../../../common/styles/RowSpacer'
import { BooksitoutServer } from '../../../../config/BooksitoutServer'
import useLoginStore from '../../../login/useLoginStore'

const UserBookRecommendationCard = () => {
	const isLoggedIn = useLoginStore((state) => state.isLoggedIn())
	const [isLoading, recommendations, setRecommendations] = useUserBookRecommendations(5)

	const handleLikeToggle = (id: number) => {
		if (!isLoggedIn) return

		const target = recommendations.find((r) => r.id === id)
		if (!target) return

		const willLike = !target.isLiked

		setRecommendations((prev) =>
			prev.map((r) => (r.id === id ? { ...r, isLiked: willLike, likeCount: r.likeCount + (willLike ? 1 : -1) } : r))
		)

		const revert = () =>
			setRecommendations((prev) =>
				prev.map((r) => (r.id === id ? { ...r, isLiked: !willLike, likeCount: r.likeCount + (willLike ? -1 : 1) } : r))
			)

		if (willLike) {
			BooksitoutServer.post(`/v1/book-user-recommendations/${id}/like`).catch(() => revert())
		} else {
			BooksitoutServer.delete(`/v1/book-user-recommendations/${id}/like`).catch(() => revert())
		}
	}

	return (
		<Card>
			<CardBodyContentContainer>
				<CardTitle icon={<BooksitoutIcon.recommend />} title="사용자들의 책 추천" url="/community/book-recommendations" />

				{isLoading ? (
					<>
						{Array.from({ length: 3 }).map((_, i) => (
							<React.Fragment key={i}>
								<UserBookRecommendationListRowLoading colorType={'card-card'} />
								<RowSpacer size={5} />
							</React.Fragment>
						))}
					</>
				) : recommendations.length === 0 ? (
					<div style={{ paddingTop: '80px', paddingBottom: '80px' }}>
						<NoContent message={'아직 추가된 책 추천이 없어요'} />
					</div>
				) : (
					recommendations.map((rec) => (
						<React.Fragment key={rec.id}>
							<UserBookRecommendationListRow recommendation={rec} colorType={'card-card'} onLikeToggle={handleLikeToggle} />
						</React.Fragment>
					))
				)}
			</CardBodyContentContainer>
		</Card>
	)
}

export default UserBookRecommendationCard
